module.exports = __webpack_public_path__ + "media/soundtrack.a78fb49f.mp3";